import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import LookOutRegistered from './LookOutRegistered'
import LookOutEmergency from './LookOutEmergency'
import LookOutConfirmed from './LookOutConfirmed'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { MdErrorOutline, MdOutlineCalendarMonth, MdOutlineHowToReg, MdOutlineEmergency, MdSearch, MdClose } from 'react-icons/md'
import { FaClinicMedical, FaUserPlus, FaHeartbeat } from 'react-icons/fa'
import { HiOutlineClipboardCheck } from 'react-icons/hi'
import { GetAllByUser } from "../../../configurations/crud/opdCentersCrud"
import Datepicker from 'react-tailwindcss-datepicker'
import Select from '../../controls/Select'
import moment from 'moment'
import ForDateShortReport from '../report/ForDateShortReport'

export default function LookOut({ }) {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [serachPatient, setSerachPatient] = useState("")
    const [isSerachPatient, setIsSerachPatient] = useState(0)
    const [opdCenters, setOpdCenter] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState("");
    const [viewUsers, setViewUsers] = useState(1);
    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    useEffect(() => {
        getAllOpdCenters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    const TABS = [
        {
            id: 1,
            label: "Registered",
            Icon: FaUserPlus,
            active: "bg-blue-500 text-white shadow",
            dot: "bg-blue-500",
        },
        {
            id: 2,
            label: "Confirmed",
            Icon: HiOutlineClipboardCheck,
            active: "bg-green-500 text-white shadow",
            dot: "bg-green-500",
        },
        {
            id: 3,
            label: "Emergency",
            Icon: FaHeartbeat,
            active: "bg-red-500 text-white shadow",
            dot: "bg-red-500",
        },
    ]
    const searchScope = viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"
    const forDate = moment(new Date(value.startDate)).format("MM/DD/YYYY")
    const selectedCenterName = opdCenters.find(c => c.id == selectedCenter)?.centerName

    function handleSearch() {
        setIsSerachPatient(pre => pre + 1)
    }

    return (
        <Container>
            <div className="flex w-full flex-col gap-3 px-2 pb-4 sm:px-4">

                {/*
                  Filter is a plain card-styled container (NOT the <Card> component)
                  so overflow stays visible and the datepicker popover isn't clipped.
                */}
                <div className="relative z-30 overflow-visible rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-md">
                    {/* header strip */}
                    <div className="flex items-center gap-2 rounded-t-2xl border-b border-gray-100 bg-gradient-to-r from-brand-50 to-white px-4 py-3">
                        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-brand-500 text-white shadow-sm">
                            <FaClinicMedical className="text-base" />
                        </span>
                        <div className="min-w-0">
                            <h2 className="truncate text-base font-semibold leading-tight text-gray-800">Look Out OPD</h2>
                            <p className="truncate text-xs text-gray-500">
                                {selectedCenterName
                                    ? `${selectedCenterName} • ${moment(new Date(value.startDate)).format("DD MMM YYYY")}`
                                    : "Select a center and date to view patients"}
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2 sm:gap-4">
                        <div className="w-full">
                            <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-gray-700">
                                <FaClinicMedical className="text-red-600" />
                                Select Center
                            </label>
                            <Select
                                Icon={<FaClinicMedical className="text-lg text-red-600" />}
                                value={selectedCenter}
                                onChange={(e) => setSelectedCenter(e.target.value)}
                            >
                                <option value="">Select Center...</option>
                                {opdCenters.map(item => (
                                    <option key={item.id} value={item.id}>{item.centerName}</option>
                                ))}
                            </Select>
                        </div>
                        <div className="relative z-50 w-full">
                            <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-gray-700">
                                <MdOutlineCalendarMonth className="text-base text-brand-600" />
                                Select Date
                            </label>
                            <Datepicker
                                popoverDirection="down"
                                useRange={false}
                                asSingle={true}
                                displayFormat="DD/MM/YYYY"
                                readOnly={true}
                                primaryColor={"sky"}
                                value={value}
                                onChange={newValue => setValue(newValue)}
                                containerClassName="relative z-[100]"
                                inputClassName="outline-none bg-white border border-gray-200 text-gray-900 text-sm rounded-xl shadow-soft focus:ring-2 focus:ring-brand-400/30 focus:border-brand-400 w-full p-2.5"
                            />
                        </div>
                    </div>
                </div>

                {/* empty state before filters are chosen */}
                {!(selectedCenter && value.startDate) &&
                    <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-4 py-10 text-center">
                        <span className="grid h-12 w-12 place-items-center rounded-full bg-white text-gray-400 shadow-sm">
                            <MdOutlineHowToReg className="text-2xl" />
                        </span>
                        <p className="text-sm font-medium text-gray-600">No center selected</p>
                        <p className="text-xs text-gray-400">Choose a center and date above to see registered, confirmed and emergency patients.</p>
                    </div>
                }

                {selectedCenter && value.startDate &&
                    <>
                        <ForDateShortReport centerId={selectedCenter} forDate={forDate} />

                        <Card isBorder={true}>
                            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                                {/* tabs */}
                                <div className="flex gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1 md:shrink-0">
                                    {TABS.map(({ id, label, Icon, active }) => (
                                        <button
                                            key={id}
                                            type="button"
                                            onClick={() => setViewUsers(id)}
                                            aria-pressed={viewUsers == id}
                                            className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${viewUsers == id ? active : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                                        >
                                            <Icon className="text-sm sm:text-base" />
                                            {label}
                                        </button>
                                    ))}
                                </div>

                                {/* search (available on all sizes) */}
                                <div className="flex w-full items-center gap-2 md:max-w-sm">
                                    <div className="relative w-full">
                                        <MdSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-gray-400" />
                                        <input
                                            type="text"
                                            value={serachPatient}
                                            onChange={(e) => setSerachPatient(e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                                            placeholder={`Search ${searchScope} patient...`}
                                            className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 pl-10 pr-9 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500"
                                        />
                                        {serachPatient &&
                                            <button
                                                type="button"
                                                onClick={() => { setSerachPatient(""); handleSearch(); }}
                                                className="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full text-gray-400 transition hover:bg-gray-200 hover:text-gray-600"
                                            >
                                                <MdClose className="text-base" />
                                                <span className="sr-only">Clear search</span>
                                            </button>
                                        }
                                    </div>
                                    <button
                                        onClick={handleSearch}
                                        className="grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-brand-600 bg-brand-500 text-white transition hover:bg-brand-600 focus:outline-none focus:ring-4 focus:ring-brand-600/40"
                                    >
                                        <MdSearch className="text-lg" />
                                        <span className="sr-only">Search</span>
                                    </button>
                                </div>
                            </div>

                            {/* tab content */}
                            <div className="mt-3">
                                {viewUsers == 1 &&
                                    <LookOutRegistered isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                                {viewUsers == 2 &&
                                    <LookOutConfirmed isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                                {viewUsers == 3 &&
                                    <LookOutEmergency isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                            </div>
                        </Card>
                    </>
                }
            </div>
        </Container>
    )
}